export default "__VITE_ASSET__CsX1noiE__"